import { FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE } from 'src/app/pages/scheduling/constants/find-replacement-support-segment-source.constants';
import { NotificationBase } from './notification-base';

export class NotificationScheduling extends NotificationBase {
  process(): void {
    if (!this.isCurrentPage()) {
      this.handleAlert();
    }
  }

  /**
   * Navigate to the scheduled event page using either the occurrenceIdType & occurrenceId if they exist, otherwise
   * the derivedUniqueId.
   */
  protected viewNotification(): void {
    const { id, idType } = this.getNotificationIds();
    if (id && idType) {
      this.navCtrl.navigateForward(`/plan-session/plan-session-detail/${idType}/${encodeURIComponent(id)}`, {
        queryParams: this.queryParams(),
      });
    } else {
      console.error('[Scheduled Event Push Notification] No occurrence_id or occurrence_id_type', this.item);
      this.navCtrl.navigateForward(
        `plan-session/plan-session-detail/${encodeURIComponent(this.item?.derived_unique_id)}`,
        { queryParams: this.queryParams() },
      );
    }
  }

  private handleAlert(): void {
    this.showAlert();
  }

  /**
   * Checks to see whether the current page matches the scheduled event identifier.
   * i.e. occurrenceIdType & occurrenceId if the feature flag is on otherwise the derivedUniqueId.
   *
   * @returns true if the current page is the session.
   */
  private isCurrentPage(): boolean {
    const { id, idType } = this.getNotificationIds();
    if (idType && id) {
      // encoding the derived_unique_id passed from the backend in order to compare with the currentRoute which is already encoded
      return this.currentRoute() === `/plan-session/plan-session-detail/${idType}/${encodeURIComponent(id)}`;
    }
    return (
      this.currentRoute() === `/plan-session/plan-session-detail/${encodeURIComponent(this.item?.derived_unique_id)}`
    );
  }

  /**
   * Retrieves the session occurrence id and type.
   */
  private getNotificationIds(): { id: string; idType: string } {
    return {
      id: this.item.occurrence_id || this.item.session_id,
      idType: this.item.occurrence_id_type || this.item.session_id_type,
    };
  }

  private queryParams(): Record<string, string> {
    return {
      source: FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE.notification,
    };
  }
}
